export const ServicesElems = {
  withImg: 'service_with_img',
  withTitle: 'service_with_title',
  withQuote: 'service_with_quote',
  withList: 'services_with_list',
  withLine: 'services_with_line'
};
